<template lang="html">
    <div>
        <contacto/>
    </div>
</template>

<script>
import Contacto from '../components/contactoComponent'
export default {
    components:{
        Contacto
    }
    
}
</script>
